import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=6ebece99&scoped=true"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"
import style0 from "./Affiliation.vue?vue&type=style&index=0&id=6ebece99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebece99",
  null
  
)

export default component.exports